// The list's pager: "Mostrando a–b de n", rows per page (25/50/100) and previous/next. Moved out of
// `PanelCierres.jsx` for the panel grouped by date (B-70), which pages its dates the same way.
import { ChevronLeft, ChevronRight } from "lucide-react";
import { Button, Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@mantis-sas/ui";
import { guia } from "../../../utils/cierreTours";

// `extra` sits beside the count — the panel grouped by date's legend.
export function Paginacion({ inicio, porPagina, total, paginaActual, totalPaginas, onPorPagina, onPagina, extra = null }) {
  return (
    <div {...guia("Páginas", "Cuántas filas ves por página (25, 50 o 100) y en qué página estás.")} className="flex flex-col items-center gap-1.5 border-t bg-card px-2.5 py-1.5 sm:flex-row sm:justify-between">
      <div className="flex items-center gap-4 text-[11px] text-brinks-muted-foreground">
        <p className="text-[11px] tabular-nums">
          {total === 0 ? "Sin resultados" : `Mostrando ${inicio + 1}–${Math.min(inicio + porPagina, total)} de ${total}`}
        </p>
        {extra}
      </div>
      <div className="flex items-center gap-1.5">
        <span className="hidden text-[11px] text-brinks-muted-foreground sm:inline">Filas</span>
        <Select value={String(porPagina)} onValueChange={(v) => onPorPagina(Number(v))}>
          <SelectTrigger className="h-7 w-[64px] rounded-[7px] text-[11px]" aria-label="Filas por página">
            <SelectValue>{porPagina}</SelectValue>
          </SelectTrigger>
          <SelectContent className="brinks-scope font-redhat">
            <SelectItem value="25">25</SelectItem>
            <SelectItem value="50">50</SelectItem>
            <SelectItem value="100">100</SelectItem>
          </SelectContent>
        </Select>
        <Button variant="outline" size="sm" className="h-7 w-7 px-0" aria-label="Página anterior" disabled={paginaActual <= 1} onClick={() => onPagina((p) => Math.max(1, p - 1))}>
          <ChevronLeft className="h-3.5 w-3.5" />
        </Button>
        <span className="min-w-[58px] text-center text-[11px] text-brinks-muted-foreground tabular-nums">
          {paginaActual} / {totalPaginas}
        </span>
        <Button variant="outline" size="sm" className="h-7 w-7 px-0" aria-label="Página siguiente" disabled={paginaActual >= totalPaginas} onClick={() => onPagina((p) => Math.min(totalPaginas, p + 1))}>
          <ChevronRight className="h-3.5 w-3.5" />
        </Button>
      </div>
    </div>
  );
}
